import { Injectable } from '@angular/core';

@Injectable()
export class Merchant {

    get companyName(): string {
        return localStorage.getItem('merchant.companyName');
    }
    set companyName(companyName: string) {
        localStorage.setItem('merchant.companyName', companyName);
    }

    get country(): string {
        return localStorage.getItem('merchant.country');
    }
    set country(country: string) {
        localStorage.setItem('merchant.country', country);
    }

    get currency(): string {
        return localStorage.getItem('merchant.currency');
    }
    set currency(currency: string) {
        localStorage.setItem('merchant.currency', currency);
    }

    get formattedCurrency(): string {
        const STANDARD_CURRENCY_CODE_LENGHT = 3;
        const currency: string = localStorage.getItem('merchant.currency');
        return currency ? currency.substring(0, STANDARD_CURRENCY_CODE_LENGHT) : "";
    }

    /**
     * maxCharge is saved in units.
     * For examples, if the merchant max charge = 1.00 €  maxCharge = 1
     */
    get maxCharge(): number {
        return +localStorage.getItem('merchant.maxCharge');
    }
    /**
     * maxCharge is saved in units.
     * For examples, if the merchant max charge = 1.00 €  maxCharge = 1
     */
    set maxCharge(maxCharge: number) {
        localStorage.setItem('merchant.maxCharge', maxCharge.toString());
    }


    get threshold(): number {
        return +localStorage.getItem('merchant.threshold');
    }
    set threshold(threshold: number) {
        localStorage.setItem('merchant.threshold', threshold.toString());
    }

    get decimalPlaces(): number {
        return +localStorage.getItem('merchant.decimalPlaces');
    }
    set decimalPlaces(decimalPlaces: number) {
        localStorage.setItem('merchant.decimalPlaces', decimalPlaces.toString());
    }

    get email(): string {
        return localStorage.getItem('merchant.email');
    }
    set email(email: string) {
        localStorage.setItem('merchant.email', email);
    }

    get id(): number {
        return +localStorage.getItem('merchant.id');
    }

    get userId(): number {
        return +localStorage.getItem('merchant.userId');
    }

    get username(): string {
        return localStorage.getItem('merchant.username');
    }
    set username(username: string) {
        localStorage.setItem('merchant.username', username);
    }

    get createdAt(): Date {
        return new Date(localStorage.getItem('merchant.createdAt'));
    }
    set createdAt(createdAt: Date) {
        localStorage.setItem('merchant.createdAt', createdAt.toString());
    }

    get logo(): string {
        return localStorage.getItem('merchant.logo');
    }
    set logo(logo: string) {
        localStorage.setItem('merchant.logo', logo);
    }

    constructor() {
    }
}
